import React from 'react';

import InvestmentCardInvestmentTypeDisplay from '../components/InvestmentCardInvestmentTypeDisplay';

const section1FactoryFactory = (props) => {
  const {
    investmentTypeDisplay,
    eligible1031,
    reit,
  } = props;

  const section1Factory = () => {
    return (
      <InvestmentCardInvestmentTypeDisplay
        investmentTypeDisplay={investmentTypeDisplay}
        eligible1031={eligible1031}
        reit={reit}
      />
    );
  };

  return section1Factory;
};

export default section1FactoryFactory;
